var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsHtml(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9297 0H64.1602V11.1328H74.5117V0H85.7422V33.6914H74.5117V22.4609H64.2578V33.6914H52.9297V0ZM100.586 11.2305H90.6738V0H121.777V11.2305H111.816V33.6914H100.586V11.2305ZM126.709 0H138.477L145.703 11.8652L152.93 0H164.697V33.6914H153.467V16.9922L145.605 29.1016L137.744 16.9922V33.6914H126.709V0ZM170.264 0H181.494V22.5586H197.412V33.6914H170.264",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5391 229.98L36.4258 49.1211H213.574L197.461 229.883L124.854 250L52.5391 229.98ZM68.7174 86.4583L125 86.4583V63.9648H197.412L183.594 218.262L125 234.619V211.449L124.967 211.458L80.1758 200L77.0508 164.583H98.9258L99.9674 182.292L124.967 188.542L125 188.534V153.125L74.9674 153.125L68.7174 86.4583ZM125 131.25V108.333L93.7174 108.333L95.8008 131.25L125 131.25Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125 211.449V234.619L183.594 218.262L197.412 63.9648H125V86.4583H180.176L178.092 108.333H125V131.25H176.009L170.801 198.958L125 211.449ZM125 188.534L149.967 182.292L152.051 153.125H125V188.534Z",
    fill: "current",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsHtml);
export default __webpack_public_path__ + "static/media/skills-html.3fa4e8b4501ef2015819794952c588a3.svg";
export { ForwardRef as ReactComponent };